// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3sYLV","inputWrap":"styles_inputWrap__29ZiJ","input":"styles_input__2wm3n"};